import {
  CreatePriceLevelConfigsModalComponent
} from "../components/modals/create-price-level-configs-modal/create-price-level-configs-modal.component";
import {PriceLevelConfigsModalConfig} from "../types/price-level-configs-page-modals-config.types";

const priceLevelConfigsFieldConfig = {
  createPriceLevelConfigsModal: { component: CreatePriceLevelConfigsModalComponent, width: '450px' }
} as const;

export const priceLevelConfigsModalConfig: Record<string, PriceLevelConfigsModalConfig> =
  Object.fromEntries(
    Object.entries(priceLevelConfigsFieldConfig).map(([fieldName, config]) => [
      fieldName,
      {
        ...config,
        fieldName
      }
    ])
  );
